import styled from 'styled-components';

const Container = styled.span`
  color: ${props => props.theme.colors.textSecondary};
  font-size: 12px;
  align-items: center;
  white-space: nowrap;
  & img {
    width: 9px;
    vertical-align: middle;
    position: relative;
    padding-left: 1px;
    margin-right: 9px;
  }
  & span {
    display: inline-block;
  }
}`;

export default Container;
